module.exports = __webpack_public_path__ + "img/mantenimiento_equipos.dcef65a2.png";